import { ReportProfileAlertResourceBaseModel } from '../../../profile/report-profile-alert-resource-base-model';
import { ZimbraMailingReportProfileAlertPermissionsModel } from '../../../zimbra/mailing/profile/zimbra-mailing-report-profile-alert-permissions-model';
import { ZimbraMailingReportProfileDelegate } from '../../../zimbra/mailing/profile/zimbra-mailing-report-profile-delegate';

export class ZimbraMailingReportProfileAlertDelegateModel extends ReportProfileAlertResourceBaseModel {
  delegate: ZimbraMailingReportProfileDelegate;
  permissions: ZimbraMailingReportProfileAlertPermissionsModel;
}
